//* Libraries imports
import { z } from "zod";

//* Schemas imports
import { MethodPaymentEnum } from "./methodpayment";

export const FinancialConfigSchema = z.object({
  cashPrice: z.number().optional(),
  installmentPrice: z.number().optional(),
  paymentMethods: z.array(z.nativeEnum(MethodPaymentEnum)).optional(),
  maxInstallments: z.number().optional(),
  interestFreeInstallments: z.number().optional(),
  interestRate: z.number().optional(),
  standardCashDiscount: z.number().optional(),
  standardInstallmentDiscount: z.number().optional(),
  managerOverrideDiscount: z.number().optional(),
});

export type IFinancialConfig = z.infer<typeof FinancialConfigSchema>;
